import React from "react";
import { Grid, Typography, Stack } from "@mui/material";
import { Link as DomLink } from "react-router-dom";

const ShanksTab = ({ links }) => {
  return (
    <Grid container>
      <Grid item xs={3}>
        <Stack direction="column" className="navbar-stack">
          <Typography className="navbar-text">Shop by Metal Color</Typography>
          {links.ShanksLinks.MetalColor.map((link, index) => (
            <DomLink
              key={index}
              to={{
                pathname: "/products/All Shanks",
                state: {
                  Material: link.materials,
                },
              }}
              onClick={() => {
                if (window.location.pathname === "/products/All Shanks") {
                  window.location.reload();
                }
              }}
            >
              {link.label}
            </DomLink>
          ))}
          <Typography className="navbar-text" marginTop={"2rem"}>
            Shop by Shank Type
          </Typography>
          {links.ShanksLinks.ShankType.map((link, index) => (
            <DomLink
              key={index}
              to={{
                pathname: "/products/All Shanks",
                state: {
                  ShankType: link.type,
                },
              }}
              onClick={() => {
                if (window.location.pathname === "/products/All Shanks") {
                  window.location.reload();
                }
              }}
            >
              {link.label}
            </DomLink>
          ))}
        </Stack>
      </Grid>
      <Grid item xs={3}>
        <Typography className="navbar-text">Shop by Style</Typography>
        <Stack direction="column" className="navbar-stack">
          {links.ShanksLinks.ShankStyle.map((link, index) => (
            <DomLink
              key={index}
              to={{
                pathname: "/products/All Shanks",
                state: {
                  Style: link.style,
                },
              }}
              onClick={() => {
                if (window.location.pathname === "/products/All Shanks") {
                  window.location.reload();
                }
              }}
            >
              {link.label}
            </DomLink>
          ))}
        </Stack>
      </Grid>
      <Grid item xs={3}>
        <Typography className="navbar-text">
          Shop by Advanced Options
        </Typography>
        <Stack direction="column" className="navbar-stack">
          {links.ShanksLinks.ShankAdvanceOptions.map((link, index) => (
            <DomLink
              key={index}
              to={{
                pathname: "/products/All Shanks",
                state: {
                  AdvancedOptions: link.options,
                },
              }}
              onClick={() => {
                if (window.location.pathname === "/products/All Shanks") {
                  window.location.reload();
                }
              }}
            >
              {link.label}
            </DomLink>
          ))}
        </Stack>
      </Grid>
      <Grid item xs={3}>
        <Typography className="navbar-text">Additional Info</Typography>
        <Stack direction={"column"} className="navbar-stack">
          {links.AdditionalInfo.map((link, index) => (
            <DomLink key={index} to={{ pathname: link.path }}>
              {link.label}
            </DomLink>
          ))}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default ShanksTab;
